export const INPUT_HEIGHT = 40;

export const INPUT_CLEAR_BUTTON_HEIGHT = 15;

export const INPUT_DEFAULT_PADDING_TOP = 12;
